import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { SelectionModel } from '@angular/cdk/collections';
import { TripAttributes } from '@albatrosdeveloper/ave-models-package';
import { TRIP_STATUS_LABELS } from 'app/common/enums/trip-status.enum';

export interface ModalSelectTripsData {
  trips: any; // Recibe la respuesta del endpoint
  routeName: string;
}

@Component({
  selector: 'app-modal-select-trips',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatTableModule,
    MatCheckboxModule,
    MatButtonModule
  ],
  templateUrl: './modal-select-trips.component.html',
  styles: [`
    :host { display: block; min-width: 560px; color: #374151; }
    .dialog-title { margin: 0; padding: 24px 24px 8px; color: #1f2937; font-size: 20px; font-weight: 700; }
    .dialog-content { padding: 0 24px 12px; }
    .dialog-description { margin: 0 0 16px; color: #64748b; font-size: 13px; line-height: 1.5; }
    .dialog-description strong { color: #1f2937; }
    .trips-table {
      width: 100%;
      max-height: 360px;
      overflow: auto;
      border: 1px solid #dbe3ef;
      border-radius: 6px;
    }
    table { width: 100%; }
    th { background: #edf3fa; color: #334155; font-size: 12px; font-weight: 700; white-space: nowrap; }
    td { color: #475569; font-size: 12px; border-bottom: 1px solid #e2e8f0; white-space: nowrap; }
    tr.mat-mdc-row { cursor: pointer; }
    tr.mat-mdc-row:hover { background: #f8fafc; }
    .mat-column-select {
      width: 50px;
    }
    .dialog-actions { display: flex; justify-content: flex-end; gap: 10px; padding: 12px 24px 20px; }
  `]
})
export class ModalSelectTripsComponent implements OnInit {
  displayedColumns: string[] = ['select', 'id', 'dateRange', 'statusTripId', 'user', 'responsible'];
  dataSource: TripAttributes[] = [];
  selection = new SelectionModel<TripAttributes>(true, []);

  constructor(
    public dialogRef: MatDialogRef<ModalSelectTripsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalSelectTripsData
  ) {}

  ngOnInit(): void {
    // Procesar la estructura de respuesta anidada del endpoint withCountByTripv2
    let rawTrips: any[] = [];
    const res = this.data.trips;
    if (res && Array.isArray(res)) {
      if (res[0] && Array.isArray(res[0].data)) {
        rawTrips = res[0].data;
      } else {
        rawTrips = res;
      }
    } else if (res && Array.isArray((res as any).data)) {
      if ((res as any).data[0] && Array.isArray((res as any).data[0].data)) {
        rawTrips = (res as any).data[0].data;
      } else {
        rawTrips = (res as any).data;
      }
    }

    this.dataSource = rawTrips;
    // Seleccionar todos por defecto
    this.dataSource.forEach(row => this.selection.select(row));
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }

  masterToggle(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.forEach(row => this.selection.select(row));
    }
  }

  getStatusLabel(statusTripId: number): string {
    return TRIP_STATUS_LABELS[statusTripId] || `Estado ${statusTripId}`;
  }

  onConfirm(): void {
    this.dialogRef.close(this.selection.selected);
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
